import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom"
import Sidebar from "../Components/sidebar/sidebar"
import style from "./sidebarPage.module.scss"
import { VerifyTransaction } from "../actions/APIcalls"
import TransactionResult from "../Components/transactionResult/transactionResult"
import moment from 'moment-jalaali';

const PaymentResult = (props) => {
    const [transactionData, setTransactionData] = useState({})

    useEffect(async () => {
        if (props.history.location) {
            const urlParams = new URLSearchParams(window.location.search);
            const transactionId = urlParams.get('trackId');
            const orderId = urlParams.get('orderId');

            let params = {
                transactionId: transactionId
            }
            let res = await VerifyTransaction(params)
            console.log(res, "verfy");
            let data;
            if (res && res.data) {
                data = {
                    success: true,
                    trackId: res.data.refNum,
                }
            } else if (res && res.response) {
                data = {
                    success: false,
                    trackId: transactionId,
                    orderId: orderId
                }
            }
            setTransactionData({ ...data })

        }
    }, [])
    return (
        <div className={style.wrapper}>
            <div className={style.content}>
                {typeof transactionData.success !== "undefined" &&
                    <TransactionResult success={transactionData.success} data={transactionData} />
                }
            </div>
            <div className={style.sidebar}>
                <Sidebar user={props.user} />

            </div>
        </div>
    )
}
export default withRouter(PaymentResult);



